module.exports = __webpack_public_path__ + "img/caviar.c4ec6616.jpg";